import { render } from "./order-fulfillment.vue?vue&type=template&id=4119aea7&scoped=true"
import script from "./order-fulfillment.vue?vue&type=script&lang=js"
export * from "./order-fulfillment.vue?vue&type=script&lang=js"

import "./order-fulfillment.vue?vue&type=style&index=0&id=4119aea7&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4119aea7"]])

export default __exports__